import React from "react";

import useButtonLoader from "hooks/useButtonLoader";
import { CustomModal } from "components/modals/ModalBox";
import { useState } from "react";
import { toastMessage } from "utils/toastMessage";

import { Input } from "common/InputForm";

import { addProductTypeApi } from "services/product-management";

const AddNewProductType = ({
  addNewProductTypeState,
  fetchProductList,
  closeModel,
}) => {
  const [error, setError] = useState({});

  const [buttonLoader, setButtonLoader] = useButtonLoader("Add");

  // ------------ cat name holder
  const [productTypeState, setProductTypeState] = useState("");

  // ---------------------apply coupon input Checkbox

  const [discountApply, setDiscountApply] = useState(false);
  const [couponNumberState, setCouponNumberState] = useState(0);

  // Input Validation
  const validation = () => {
    let status = true;
    let errorObject = {};

    if (!productTypeState.length) {
      errorObject["brandName"] = "Product Type Name is not Set";
      status = false;
    }

    setError(errorObject);

    return status;
  };

  // Add Brand close modal
  const addBrandCloseModal = () => {
    setProductTypeState("");
    setError({});

    fetchProductList();
    closeModel();
  };

  // Add Brand handler

  const addProductHandler = async (e) => {
    e.preventDefault();

    if (validation()) {
      setButtonLoader(true);
      try {
        const dataToSend = {
          name: productTypeState,
          isDiscountAvailable: discountApply,
          discountPercentage: couponNumberState,
        };

        const { data } = await addProductTypeApi(dataToSend);
        // console.log();
        if (data.status || data.code === 200) {
          addBrandCloseModal();
        }
      } catch (e) {
        console.log("Error:", e.message);
      } finally {
        setButtonLoader(false);
      }
    }
  };

  return (
    <CustomModal
      className={"add_model"}
      show={addNewProductTypeState}
      handleClose={addBrandCloseModal}
    >
      <h3>Add New Product Type</h3>

      {/* ---------Category name and its types */}

      <div className="cat-name-and-type-container">
        {/* ---------input tag name */}
        <div>
          <Input
            type="text"
            label="Product Name"
            placeholder="Add Product Type..."
            name="BrandNameTxt"
            value={productTypeState}
            onChange={(e) => {
              setProductTypeState(e.target.value);
            }}
          />
          {error["brandName"] && (
            <p className="red-color">{error["brandName"]}</p>
          )}
        </div>
        {/* ------------set coupon and checkbox  */}
        <div className="cat-type-main-container">
          <label htmlFor="couponIdApply">
            <input
              id="couponIdApply"
              type="checkbox"
              onChange={(e) => {
                setDiscountApply(e.target.checked);
                if (!e.target.checked) {
                  setCouponNumberState(0); // Reset the state itself
                }
              }}
              value={discountApply}
              checked={discountApply}
            />{" "}
            Apply Discount
          </label>

          <Input
            type="number"
            name="couponNumber"
            value={couponNumberState}
            onChange={(e) => {
              setCouponNumberState(e.target.value);
            }}
            onKeyDown={(e) => {
              if (["e", "E", "+", "-", "."].includes(e.key)) {
                e.preventDefault();
              }
            }}
            disabled={!discountApply}
          />
        </div>
      </div>

      <div className="button_wrap">
        <button
          type="button"
          className="button light"
          onClick={addBrandCloseModal}
        >
          Cancel
        </button>
        <button
          type="button"
          ref={buttonLoader}
          onClick={addProductHandler}
          className="button"
        >
          Submit
        </button>
      </div>
    </CustomModal>
  );
};

export default AddNewProductType;
